import { SET_LAUNCH_INFO } from 'stash/actions/onboarding';

/**
 * Holds launch-info–derived onboarding context.
 * Both fields are undefined until launch-info has been fetched;
 * then null (legacy/unknown) or a string.
 */
const initialState = {
	conversionSource: undefined,
	launchLocation: undefined,
};

export default function onboarding(state = initialState, action) {
	switch (action.type) {
		case SET_LAUNCH_INFO:
			return {
				...state,
				conversionSource: action.payload.conversionSource,
				launchLocation: action.payload.location,
			};
		default:
			return state;
	}
}
